import React, {useState} from 'react';
import {UploadFile} from "antd/es/upload/interface";
import {ClaimItem} from "../../../../../models/claims/claims";
import {createFileList} from "./file_list.factory";
import {claimService} from "../../../../../services/claims/claims.service";
import {FileUploader} from "../../../../core/commons/file-uploader/file-uploader";
import {RootStoreContext} from "../../../../../stores/root/root";
import {useRequiredLayers} from "../../../../../utils/context";
import {RootControllersContext} from "../../../../../controllers/root/root.controllers";

export interface ClaimPartsImagesProps {
    item: ClaimItem;
}

export const ClaimPartsImages: React.FC<ClaimPartsImagesProps> = ({item}) => {

    const {controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)
    const [fileList, setFileList] = useState<UploadFile<any>[]>(() => createFileList(item.attachments, loginController.generateUri));

    return (
        <FileUploader
            upload={file=> claimService.uploadFileForItem(item.id, file)}
            value={fileList}
            onChange={fileList => setFileList(fileList)}
            onRemove={file => claimService.removeFile(parseInt(file.uid))}
        />
    )
};